/**
 * General views
 * Path: `@/views`
 */

import multiguard from "vue-router-multiguard"
import { requireAuth } from "@/utils/middleware"

const CompanySelector = () => import("@/views/CompanySelector.vue")
const Help = () => import("@/views/Help.vue")
const Home = () => import("@/views/Home.vue")
const NotificationsPage = () => import("@/views/NotificationsPage.vue")
const GanttAdmin = () => import("@/views/GanttAdmin.vue")
const IAChat = () => import("@/views/chat/IAChat.vue")
const IAReport = () => import("@/views/chat/IAReport.vue")

export default [
  {
    path: "/select-company",
    name: "SelectCompany",
    component: CompanySelector,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/gantt",
    name: "GanttAdmin",
    component: GanttAdmin,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/chat",
    name: "IAChat",
    component: IAChat,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/ia-report",
    name: "IAReport",
    component: IAReport,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  }
]
